import ThisModule from "./ModalConfirm";

export default ThisModule;
